import { useEffect, useState } from 'react';

/**
 * [SJGROW-2841]- SPA | Improve verification contact us experience
 * Hook that handles logic for disabling/enabling submit button in case user has verification in progress
 * 1.if user has not accepted warning and selected category is account verification, disable submit button
 * 2.if user changes category from account verification to something else, enable submit button
 * 3.if user checks the checkbox, enable submit button
 */
export const useWarningState = (
  showWarning: boolean,
  disableSubmitCallback: (disabled: boolean) => void
) => {
  const [acceptedWarning, setAcceptedWarning] = useState(false);
  const [disableInput, setDisableInput] = useState(false);

  /**
   * Reset acceptedWarning when showWarning changes
   */
  useEffect(() => {
    if (showWarning) {
      setAcceptedWarning(false);
    }
  }, [showWarning]);

  useEffect(() => {
    if (showWarning && !acceptedWarning) {
      disableSubmitCallback(true);
      setDisableInput(true);
    } else {
      disableSubmitCallback(false);
      setDisableInput(false);
    }
  }, [acceptedWarning, disableSubmitCallback, showWarning]);

  return { acceptedWarning, setAcceptedWarning, disableInput };
};